import { Button } from "@progress/kendo-react-buttons";

export interface AlertProps {
  description: string;
  buttonText: string;
  onClick: () => void;
  icon?: any;
  iconMsg?: string;
  backgroundColor?: string;
}

export function Alert(props: AlertProps) {
  console.log("icon image", props?.icon);
  return (
    <div className="flex flex-col space-y-2 ">
      <div className="flex space-x-2 items-center justify-center">
        {props?.icon && <img src={props?.icon} alt="icon" />}

        <div className={`text-2xl text-${props?.backgroundColor} text-center`}>
          {props.iconMsg}
        </div>
      </div>

      {props?.backgroundColor === "mk-bright-green" && (
        <div
          className={`border-b border-2 border-mk-bright-green w-full`}
        ></div>
      )}
      {props?.backgroundColor === "mk-red" && (
        <div className={`border-b border-2 border-mk-red w-full`}></div>
      )}
      {props?.backgroundColor === "mk-orange" && (
        <div className={`border-b border-2 border-mk-orange w-full`}></div>
      )}

      <div className="p-1 text-left text-base">
        {props.description}
      </div>
      <div className="flex justify-center items-end">
        <Button themeColor="primary" onClick={() => props.onClick()}>
          {props.buttonText}
        </Button>
      </div>
    </div>
  );
}
